/**
 * Testimonials Block — Swiper init
 *
 * Initialises a Swiper carousel for every testimonials block on the page.
 * Multiple testimonial blocks on the same page work independently.
 */

import Swiper from 'swiper/bundle';

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-testimonials-block]').forEach(function (wrapper) {
    const swiperEl   = wrapper.querySelector('.testimonials__swiper');
    const pagination = wrapper.querySelector('.testimonials__pagination');

    // Nothing to init if there's no swiper element (e.g. empty repeater)
    if (!swiperEl) return;

    new Swiper(swiperEl, {
      loop:            true,
      slidesPerView:   1,
      slidesPerGroup:  1,
      spaceBetween:    20,
      centeredSlides:  false,
      speed:           300,

      observer:        true,
      observeParents:  true,

      mousewheel: {
        forceToAxis: true,
      },

      // Pagination el is the sibling .testimonials__pagination div,
      // resolved per-wrapper so instances don't share a pagination element
      pagination: {
        el:        pagination,
        clickable: true,
      },

      // All breakpoints stay at 1 slide (matches source config)
      breakpoints: {
        480: { slidesPerView: 1 },
        768: { slidesPerView: 1 },
        992: { slidesPerView: 1 },
      },
    });
  });
});
